import actionTypes from './optOutConfirmation.actionTypes';

export function showOptOutConfirmationModal(survey = {}) {
  return { type: actionTypes.SHOW_OPT_OUT_MODAL, data: survey};
}

export function dismissOptOutModal (callback) {
  return dispatch => {
    callback && callback();
    dispatch(dismissModal());
  };
}

export function confirm (callback) {
  return (dispatch, getState) => {
    let formInstance = getState().optOutConfirmationModal.formInstance;
    callback && callback(formInstance);
    dispatch(dismissModal());
  };
}

export const setOptOutReason = (optOutReason) => {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_OPT_OUT_REASON, data: optOutReason });
  };
}

function dismissModal () {
  return {type: actionTypes.DISMISS_OPT_OUT_MODAL};
}